import { Loader } from 'BreetComponents';
import { useModalApi } from 'BreetHooks';
import { useGetTeamMemberByIdQuery } from 'BreetRedux';

import Child from './Child';

const DialogRemoveTeamMember = () => {
	const modalApis = useModalApi();
	const { getModalProps } = modalApis;

	const modalProps = getModalProps('inviteTeamMember');
	const modalMetadata = modalProps?.metadata as { teamMemberId?: string } | undefined;

	const { data: teamMemberData, isLoading: isTeamMemberLoading } = useGetTeamMemberByIdQuery(modalMetadata?.teamMemberId ?? '');

	if (isTeamMemberLoading) {
		return <Loader />;
	}

	return (
		<Child
			teamMemberData={teamMemberData}
			modalApis={modalApis}
		/>
	);
};

export default DialogRemoveTeamMember;
